












import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class FormItem extends Vue {
  // props
  @Prop({ default: "" }) readonly dataNote!: string;
  @Prop({ default: "" }) readonly dataPlaceholder!: string;
  // methods
  changeNote(note: string) {
    this.$emit("update:dataNote", note);
  }
}
